import { render, staticRenderFns } from "./MemberCallList.vue?vue&type=template&id=679e7236&scoped=true&"
import script from "./MemberCallList.vue?vue&type=script&lang=ts&"
export * from "./MemberCallList.vue?vue&type=script&lang=ts&"
import style0 from "./MemberCallList.vue?vue&type=style&index=0&id=679e7236&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679e7236",
  null
  
)

export default component.exports